import { render, staticRenderFns } from "./SvgStationScreenSet.vue?vue&type=template&id=1c60614a&scoped=true"
import script from "./SvgStationScreenSet.vue?vue&type=script&lang=js"
export * from "./SvgStationScreenSet.vue?vue&type=script&lang=js"
import style0 from "./SvgStationScreenSet.vue?vue&type=style&index=0&id=1c60614a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60614a",
  null
  
)

export default component.exports